import React from "react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import { compose, bindActionCreators } from "redux";
import { connect } from "react-redux";
import {loadSession, setLoading} from "@app/common/store/action";
import * as Yup from "yup";

import get from "lodash/get";
import { Grid, TextField, } from "@material-ui/core";

import {  withRouter } from "react-router-dom";

import {

    CHG_PWD_SUC, CHG_PWD_SUC_TITLE,
 MFA_OTP_WRONG_ERR
} from "@app/common/constants/constants";

import ErrorTextContainer from "../../../components/errortextcontainer/errortextcontainer";
import {

    FIRST_TIME_CHANGE_PASSWORD_ROUTE,
    FORGOT_CONFIRM_OTP_PASSWORD_ROUTE,
    LOGIN_ROUTE,
} from "../../../constants/routeconstants";
import CustomButton from "../../../components/custombutton/custombutton";
import {confirmResetPasswordService} from "@app/common/services/confirmresetpasswordservice";
import {
    CONF_PASS_REQUIRED,
    NEW_PASS_REQUIRED, PASSWORD_COMPLEXITY_ERR,
    PASSWORD_LENGTH,
    PASSWORD_TO_MATCH, PASSWORD_SUCCESSFUL_STATUS,
    PASSWORD_WITHOUT_UN,
    SUBMIT,
    USER_NAME_REQUIRED
} from "../../../constants/appconstants";
import style from './confirmpasswordform.module.css'
import TextFieldToolTip from "../../../components/textfieldtooltip/textfieldtooltip";
import {LOADING_SUCCESS_STATUS} from "../../../components/loading/constants";
class ConfirmResetPasswordForm extends React.Component {

    constructor(props) {
        super(props);
        const path = get(props, "location.pathname");
        const otpCode = get(this, "props.location.state.otpCode");

        const userName = get(this, "props.location.state.userName");
        if(otpCode === undefined){
            this.props.history.push({pathname:FORGOT_CONFIRM_OTP_PASSWORD_ROUTE,userName:userName})
        }
        this.state = {
            showError: 0,
            message:"",
            otpCode:otpCode,
            openDialog:false,
            userName:userName,
            dialogText:"",
            dialogTitle:"",
            errorText:"",
            isFirstTime:path===FIRST_TIME_CHANGE_PASSWORD_ROUTE,

        };
    }

    closePage = (isSubmit) =>()=> {
        const prevPath = get(this, "props.location.state.prevPath");

        if(prevPath){
            isSubmit?
                this.setState({
                    openDialog:true
                }): this.props.history.push(prevPath);

        }else{
            this.props.history.push(LOGIN_ROUTE);
        }
    };

    submitAction = (fields) => {
        const {actions} =  this.props;
        actions.setLoading(true);

        this.resetPasswordSubmit(fields)
    };

    resetPasswordSubmit = async(fields)=>{
        const { actions } = this.props;
        const {userName} = this.state;

        try{

            await confirmResetPasswordService(fields);
            actions.setLoading(false,LOADING_SUCCESS_STATUS,PASSWORD_SUCCESSFUL_STATUS,"",true);
            this.setState({dialogText:CHG_PWD_SUC,openDialog:true,dialogTitle:CHG_PWD_SUC_TITLE})
            this.props.history.push(LOGIN_ROUTE)

        }catch(e){
            // this.setState({dialogText:e,openDialog:true,dialogTitle:"Session Expired"})
            actions.setLoading(false);
            if(e=== MFA_OTP_WRONG_ERR){
                this.props.history.push({
                    pathname:FORGOT_CONFIRM_OTP_PASSWORD_ROUTE,
                    state:{
                        userName:userName,
                        error:true
                    }
                })
            }
            this.setState({errorText:e});
        }
    }



    handleDialogClose = ()=>{
        const prevPath = get(this, "props.location.state.prevPath");
        this.props.history.push(prevPath)
    }
    render() {
        const userName = get(this, "state.userName");

        const otpCode= get(this,"state.otpCode")

        return (

                        <Formik
                            initialValues={{
                                userName: userName,
                                newPassword: "",
                                confirmPassword: "",
                                otpCode:otpCode,
                            }}
                            validationSchema={Yup.object().shape({
                                userName: Yup.string().required(USER_NAME_REQUIRED),
                                newPassword: Yup.string()
                                    .test(
                                        "password contains userid",
                                        PASSWORD_WITHOUT_UN,
                                        function (pass) {
                                            const {userName} = this.parent;
                                            return !(userName !== undefined && pass !== undefined && pass.includes(userName));
                                        }
                                    )
                                    .matches(
                                        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{12,}$/,
                                        PASSWORD_COMPLEXITY_ERR
                                    )
                                    .required(NEW_PASS_REQUIRED),

                                confirmPassword: Yup.string()
                                    .oneOf([Yup.ref("newPassword"), null],PASSWORD_TO_MATCH)
                                    .required(CONF_PASS_REQUIRED),
                            })}
                            onSubmit={(fields) => {
                                this.submitAction(fields);
                            }}
                            render={({errors, touched, values,handleChange}) => (
                                <Form style={{minWidth: "330px"}}>
                                    <Grid container direction={"column"}>
                                        <Grid item>
                                            <div className={style.confirm_reset_password_form_error}>
                                                <ErrorTextContainer text={this.state.errorText}/>
                                            </div>
                                        </Grid>
                                        <Grid item className={style.confirm_reset_password_form_text_field_spacing}/>
                                        <Grid item className={style.confirm_reset_password_form_text_field_container}>
                                            <TextField
                                                id={"outlined-basic"}
                                                name="userName"
                                                variant={"outlined"}
                                                label={"Username"}
                                                onChange={handleChange}
                                                type="text"
                                                className={style.confirm_reset_password_form_text_field}
                                                value={values.userName}
                                                error={errors.userName && touched.userName}
                                                helperText={touched.userName && errors.userName}

                                            />
                                        </Grid>

                                        <Grid item className={style.confirm_reset_password_form_text_field_container}>

                                            <TextField
                                                id={"outlined-basic"}
                                                name="newPassword"
                                                type="password"
                                                variant={"outlined"}
                                                InputLabelProps={this.state.newPasswordShrink?{ style: { pointerEvents: "auto" } }:null}
                                                onChange={handleChange}
                                                label={
                                                    <div>
                                                        New Password
                                                        {this.state.newPasswordShrink ?<TextFieldToolTip text={PASSWORD_COMPLEXITY_ERR}
                                                                                                         error={errors.newPassword && touched.newPassword}/>:null}
                                                    </div>}
                                                onFocus={()=>{
                                                    this.setState({newPasswordShrink:true})
                                                    }
                                                }
                                                onBlur={() => {

                                                    this.setState({newPasswordShrink: false})
                                                    }
                                                }

                                                className={style.confirm_reset_password_form_text_field}
                                                error={errors.newPassword && touched.newPassword}
                                                helperText={touched.newPassword && errors.newPassword}
                                            />

                                        </Grid>
                                        <Grid item className={style.confirm_reset_password_form_text_field_container}>
                                            <TextField
                                                id={"outlined-basic"}
                                                name="confirmPassword"
                                                variant={"outlined"}
                                                InputLabelProps={this.state.confirmPasswordShrink?{ style: { pointerEvents: "auto" } }:null}
                                                label={
                                                    <div>
                                                        Confirm Password
                                                        {this.state.confirmPasswordShrink ?<TextFieldToolTip text={PASSWORD_COMPLEXITY_ERR}/>:null}
                                                    </div>}
                                                onFocus={()=>{
                                                    this.setState({confirmPasswordShrink:true})
                                                }
                                                }
                                                onBlur={() => {

                                                    this.setState({confirmPasswordShrink: false})
                                                }
                                                }
                                                onChange={handleChange}
                                                type="password"
                                                className={style.confirm_reset_password_form_text_field}
                                                error={errors.confirmPassword && touched.confirmPassword}
                                                helperText={touched.confirmPassword && errors.confirmPassword}
                                            />
                                        </Grid>
                                        <Grid item>
                                            <Grid container justify={"center"} className={style.confirm_reset_password_form_button_container}>
                                                <Grid item lg={12}>
                                                    <CustomButton
                                                        title={SUBMIT}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                    </Grid>
                                </Form>
                            )}
                        />

        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    session:state.session,

});


function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({ setLoading,loadSession }, dispatch),
    };
}
export default compose(connect(mapStateToProps, mapDispatchToProps),withRouter)(ConfirmResetPasswordForm);
